import React from 'react'
import './cardcomp.css'
import { useNavigate } from 'react-router-dom'

function CardComp({ data }) {   // ⬅ receive props
const navigate = useNavigate()

  return (
    <div className="container1" onClick={()=>{navigate('/cardDetails', {state:{cardData:data}})}}>
      <div className="box">
        <span className="title">{data?.title}</span>
        <div>
          <p className='details'>{data?.description}</p>
        </div>
      </div>
    </div>
  )
}

export default CardComp
